// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import LabeledString from '../labeled-string';
import {buildNumber} from '../../services/build-number';

const LabeledNumber = props =>
    <LabeledString
        {...props}
        data={buildNumber(props.data, props.options)}
    />;

LabeledNumber.displayName = 'LabeledNumber';
LabeledNumber.propTypes = {
    data: PropTypes.number,
    options: PropTypes.object
};
LabeledNumber.defaultProps = {
    options: {}
};

export default LabeledNumber;



// WEBPACK FOOTER //
// ./src/shared/components/labeled-number/index.js